import React from 'react';
import AntButton, { ButtonProps as AntButtonProps } from 'antd/lib/button';
import { ClearOutlined } from '@ant-design/icons';
import RouterLink from './RouterLink';
import useComponentConfiguration from 'DisplayFramework/useComponentConfiguration';

export type ButtonProps = Omit<AntButtonProps, 'children'> & {
  to?: string;
  comcode: string;
};

const ClearButton = ({ comcode, ...otherProps }: ButtonProps) => {
  const { isHidden, style } = useComponentConfiguration(comcode);

  if (isHidden) {
    return null;
  }

  const props = {
    ...otherProps,
    style,
  };

  if (props.to) {
    return <RouterLink component={AntButton} {...props} />;
  } else {
    return (
      <AntButton
        htmlType="button"
        {...props}
        icon={<ClearOutlined />}
        style={{ width: '100%', height: 50 }}
      />
    );
  }
};

export default ClearButton;
